import React from "react";
import MaatraLogo from "@/components/ui/atoms/MaatraLogo";
import MTopBar from "@/components/ui/atoms/MTopBar";
import { IconPhone, IconMail } from "@tabler/icons-react";
import styles from "./MOnboardingHeader.module.css";

interface MOnboardingHeaderProps {
  currentStep?: number;
  totalSteps?: number;
  onBack?: () => void;
  onExit?: () => void;
  exitPath?: string;
  showIcon?: "phone" | "email";
}

const MOnboardingHeader: React.FC<MOnboardingHeaderProps> = ({
  currentStep,
  totalSteps,
  onBack,
  exitPath = "/",
  showIcon,
}) => {
  return (
    <>
      <div className={styles.headerContainer}>
        {/* Use MTopBar for back and exit buttons */}
        <MTopBar
          onBack={onBack}
          exitPath={exitPath}
          hideProfilePicker
          withBackground={false}
          disableSticky
        />

        {/* Background Maatra Logo */}
        <div className={styles.logoBackground}>
          <MaatraLogo fill="#e6def6" size={430} />
        </div>
      </div>

      {/* Step indicators or icon - outside header container so they can overflow */}
      {showIcon ? (
        <div className={styles.iconIndicator}>
          <div className={styles.iconWrapper}>
            <div className={styles.iconCircle}>
              {showIcon === "phone" ? (
                <IconPhone size={32} color="#fff" />
              ) : (
                <IconMail size={32} color="#fff" />
              )}
            </div>
          </div>
        </div>
      ) : totalSteps && currentStep ? (
        <div className={styles.stepIndicators}>
          {Array.from({ length: totalSteps }, (_, index) => {
            const stepNumber = index + 1;
            const isActive = stepNumber === currentStep;

            return (
              <div className={styles.stepWrapper} key={stepNumber}>
                <div
                  className={`${styles.stepCircle} ${
                    isActive ? styles.stepActive : styles.stepInactive
                  }`}
                >
                  {stepNumber}
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
    </>
  );
};

export default MOnboardingHeader;
